import { ContactConfig } from "./contacts";
import { client } from "../../client";

export const getContactConfig = () => {
  return client
    .get<ContactConfig>("contacts/config")
    .then((response) => response?.data);
};
